export default __webpack_public_path__ + "static/media/sunsetashram.006a7a1a.jpg";